<template>
  <div class="copyright">
    &copy; 2020
    <a href="https://www.godjiyi.cn/" target="_blank" style="color: #07b994;">戈吉</a>·
    <a href="http://www.beian.miit.gov.cn/" target="_blank" style="color:#000000;">苏ICP备17010322号-1</a>
  </div>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>

<style scoped>
.copyright {
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  font-size: 14px;
}
.copyright a {
  text-decoration: none;
  outline: none;
  border-bottom: 1px solid #999;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue